export enum StorePickerFeature {
    OPEN_ON_SUNDAY = "openOnSunday",
    BUY_ONLINE_PICKUP_IN_STORE = "buyOnlinePickupInStore",
}
